import { html } from 'onefold';

export type CalloutType = 'info' | 'warn' | 'danger';

export function Callout(content: string, type: CalloutType = 'info'): Node {
  const cls = type === 'warn' ? 'callout callout-warn'
    : type === 'danger' ? 'callout callout-danger'
    : 'callout';

  return html`<div class=${cls}><p>${content}</p></div>`;
}

export function CalloutNode(content: Node, type: CalloutType = 'info'): Node {
  const cls = type === 'warn' ? 'callout callout-warn'
    : type === 'danger' ? 'callout callout-danger'
    : 'callout';

  return html`<div class=${cls}>${content}</div>`;
}
